const carouselItems = [
  {
    id: 1,
    title: '某顶流男星深夜密会门：完整时间线与多方回应汇总',
    excerpt: '从酒店同框照片曝光到双方工作室回应，我们为你梳理了这一事件的完整脉络，以及各大社交平台的最新讨论风向。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20night%20cityscape%20with%20luxury%20hotel%20silhouette%2C%20warm%20golden%20and%20deep%20blue%20color%20scheme%2C%20abstract%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20no%20visible%20people%20or%20text&width=1200&height=600&seq=carousel-bg-01&orientation=landscape',
    tag: '重磅追踪',
    time: '持续更新中',
  },
  {
    id: 2,
    title: '综艺录制冲突内幕：知情人曝光节目组压榨嘉宾细节',
    excerpt: '某热门综艺录制现场爆发冲突的背后，是长达数月的矛盾积累。多位前工作人员匿名爆料节目制作中的种种不规范操作。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20setting%20with%20contrasting%20warm%20and%20cool%20stage%20lighting%2C%20empty%20director%20chairs%2C%20broadcast%20equipment%20silhouettes%2C%20cinematic%20wide%20angle%2C%20tension%20atmosphere%2C%20no%20people&width=1200&height=600&seq=carousel-bg-02&orientation=landscape',
    tag: '独家内幕',
    time: '3小时前',
  },
  {
    id: 3,
    title: '年度CP分手真相：从甜蜜互动到互删动态全记录',
    excerpt: '曾经被誉为圈内最甜CP的两人突然宣布分手，震惊全网。我们整理了两人从相识、相恋到分手的完整时间线及关键细节。',
    image: 'https://readdy.ai/api/search-image?query=Split%20composition%20of%20warm%20sunset%20and%20cool%20twilight%20sky%2C%20abstract%20emotional%20landscape%2C%20soft%20pastel%20gradient%2C%20cinematic%20color%20grading%2C%20romantic%20melancholy%20mood%2C%20no%20text&width=1200&height=600&seq=carousel-bg-03&orientation=landscape',
    tag: '深度分析',
    time: '5小时前',
  },
  {
    id: 4,
    title: '网红偷税风波升级：税务局已介入，涉案金额或超千万',
    excerpt: '继知名网红被曝偷税漏税后，事件持续发酵。知情人士透露税务部门已正式立案调查，若属实可能面临巨额罚款。',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20government%20building%20facade%20with%20dramatic%20shadow%20patterns%2C%20formal%20architectural%20photography%2C%20overcast%20sky%2C%20serious%20mood%2C%20clean%20composition%2C%20no%20signage%20or%20text%20visible&width=1200&height=600&seq=carousel-bg-04&orientation=landscape',
    tag: '突发事件',
    time: '7小时前',
  },
  {
    id: 5,
    title: '娱乐圈"清朗行动"再升级：多位艺人社交账号异常',
    excerpt: '近期多位明星社交账号出现异常状态，粉丝纷纷猜测与新一轮行业整顿有关。我们分析了此次行动可能涉及的范围和影响。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20social%20media%20interface%20concept%20with%20glowing%20notification%20icons%2C%20dark%20mode%20aesthetic%2C%20floating%20user%20profile%20silhouettes%2C%20cyber%20minimalism%2C%20no%20text%20visible&width=1200&height=600&seq=carousel-bg-05&orientation=landscape',
    tag: '行业动态',
    time: '9小时前',
  },
  {
    id: 6,
    title: '某国际电影节获奖影片被指抄袭，导演长文回应质疑',
    excerpt: '获奖影片陷入抄袭争议后，导演本人发布长文逐一回应质疑点。我们对比了争议双方的核心论据，带你理清事件全貌。',
    image: 'https://readdy.ai/api/search-image?query=Empty%20premium%20cinema%20auditorium%20with%20warm%20ambient%20lighting%20and%20red%20velvet%20seats%2C%20projector%20beam%20of%20light%2C%20atmospheric%20photography%2C%20no%20screen%20content%20visible%2C%20classic%20movie%20theater%20aesthetic&width=1200&height=600&seq=carousel-bg-06&orientation=landscape',
    tag: '争议追踪',
    time: '11小时前',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium mb-3">
            <i className="ri-fire-line"></i>
            今日焦点
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            今日重磅大瓜
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            编辑精选今日最值得关注的六大娱乐热点，深度追踪，全面呈现
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-primary-500 text-background-50 text-xs px-3 py-1 rounded-full font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-4 right-4">
                  <span className="text-xs text-background-50/90 bg-foreground-950/40 backdrop-blur-sm px-2 py-0.5 rounded">
                    {item.time}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-foreground-900 text-base mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {Math.floor(Math.random() * 50 + 10)}万阅读
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i> {Math.floor(Math.random() * 2000 + 500)}评论
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}